import {Component, Injectable, Input, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Account, LoginFormModel, RegistrationFormModel, Stormpath} from 'angular-stormpath';
import {ReplaySubject} from 'rxjs';
import {NgForm} from '@angular/forms';
import {FormErrors} from '../../components/forms/validation/form-validator.class';
import {FormManager, FormSubmissionStatusCode} from '../../components/forms/form-manager.class';
import {RECAPTCHA_SITE_KEY} from '../../infrastructure/recaptcha/recaptcha.config';
import {RecaptchaComponent} from 'ng2-recaptcha';
import {CapslockDetector} from '../../components/forms/validation/capslock/capslock-detector.class';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {NpiService} from '../../domain/model/npi/npi.service';
import {Npi} from '../../domain/model/npi/npi.model';

interface FormModel extends RegistrationFormModel {}

@Component({
    template: require('./register-page.component.html'),
    styles: [require('./register-page.component.scss')]
})
@Injectable()
export class RegisterPageComponent implements OnInit {

    @Input() autoLogin: boolean;
    @ViewChild('capslockTooltip') private readonly _capslockTooltip: NgbTooltip;

    protected model: Object;
    protected error: string;
    protected viewModel$: Observable<Object>;
    protected formModel: FormModel;
    protected unverified: boolean;
    protected canLogin: boolean;
    protected firstStep: boolean;
    protected lastStep: boolean;
    protected npiResultsStep: boolean;
    protected npiResult: Npi;
    protected registered: boolean;

    private _capslockDetector = new CapslockDetector();

    readonly form$ = new ReplaySubject<NgForm>(1);
    formErrors: FormErrors = {};
    private readonly _formManager: FormManager<Account>;

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    @ViewChild(RecaptchaComponent) captcha: RecaptchaComponent;

    recaptchaSiteKey = RECAPTCHA_SITE_KEY;

    registering: boolean = false;
    loading: boolean = false;

    get continueButtonDisabledValue(): string | null {
        return this.registering || this.loading ? '' : null;
    }

    constructor(public stormpath: Stormpath, fmgm: FormManager.InjectedMembers, private readonly _npiService: NpiService) {
        this.unverified = false;
        this.canLogin = false;
        this.firstStep = true;
        this.formModel = {
            email: '',
            surname: '',
            givenName: '',
            password: '',
            npi: '',
            recaptcha_response: ''
        };
        this._formManager = new FormManager<Account>(
            fmgm,
            this.form$,
            Observable.of(() => this.stormpath.register(this.formModel)),
            undefined,
            false
        );
        //this.npiResult;// = new Npi();
    }

    ngOnInit() {
        this.stormpath.getRegistrationViewModel()
            .subscribe(model => {
                    this.model = model;
                }, error =>
                    this.error = error.message
            );
        this._formManager.displayedErrors$.subscribe(errors => this.formErrors = errors);
    }

    searchNpi() {
        this._formManager.validate();
        this._formManager.hasErrors$.first().subscribe(hasErrors => {
            if (!hasErrors) {
                this.loading = true;
                this._npiService.search(this.formModel.npi).subscribe(result => {
                        this.npiResult = result;
                        this.firstStep = false;
                        this.npiResultsStep = true;
                        this.lastStep = false;
                        this.loading = false;
                    }, error => {
                        this.error = 'Unable to find the Npi number. Please contact us for further assitance.';
                        this.firstStep = false;
                        this.npiResultsStep = true;
                        this.lastStep = false;
                        this.loading = false;
                    }
                );
            }
        });
    }

    goFirstStep() {
        this.firstStep = true;
        this.npiResultsStep = false;
        this.lastStep = false;
        this.error = '';
        this._formManager.cleanErrors();
        delete this.npiResult;
    }

    goNPIResultStep() {
        if (this.npiResult) {
            this.firstStep = false;
            this.npiResultsStep = true;
        } else {
            this.firstStep = true;
            this.npiResultsStep = false;
        }
        this.lastStep = false;
        this.error = '';
        this._formManager.cleanErrors();
    }

    confirmData(sendNpi: boolean) {
        this.firstStep = false;
        this.npiResultsStep = false;
        this.lastStep = true;
        this.error = '';
        this._formManager.cleanErrors();
        if (sendNpi) {
            this.formModel.npiRegistry = this.npiResult;
        } else {
            delete this.formModel.npi;
            delete this.formModel.npiRegistry;
            delete this.npiResult;
        }
    }

    register() {
        this.registering = true;
        delete this.formModel.npi;
        this._formManager.save()
            .finally(() => this.captcha.reset())
            .subscribe(result => {
                if (result.status.code === FormSubmissionStatusCode.SUBMITTED) {
                    let account = result.data!;
                    this.registered = true;
                    this.lastStep = false;
                    this.unverified = account.status === 'UNVERIFIED';
                    this.canLogin = account.status === 'ENABLED';

                    if (this.canLogin && this.autoLogin) {
                        let loginAttempt: LoginFormModel = {
                            login: this.formModel.email as string,
                            password: this.formModel.password as string
                        };

                        this.stormpath.login(loginAttempt);
                    }
                }
                else this.registering = false;
            }, error => {
                let errorMessage = error.message;
                if (errorMessage === 'login: An object with this field already exists in the current organization') {
                    errorMessage = 'This Email address is already registered. Please <a href="/login">Login</a>.';
                }
                this.error = errorMessage;
                this.registering = false;
            });
    }

    onSubmit() {
        this.register();
    }

    handlePasswordInputKeypress(event: KeyboardEvent) {
        if (this._capslockDetector.isCapslockOn(event)) this._capslockTooltip.open();
        else this._capslockTooltip.close();
    }

    handlePasswordInputBlur() {
        this._capslockTooltip.close();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/register/register-page.component.ts